<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Hardware Management</h5>
  </div>
  <div id="mainContent" class="container ">
    <div class="pt-3 pb-2">
      <div class="row">
        <div class="col-sm-3">
          <div class="row" *ngIf="hasAccess('IT Reports')">
            <label class="col-sm-3 col-form-label">Branch</label>
            <div class="col-sm-8">
              <select class="form-control form-control-xs" id="BranchName" name="BranchName" [(ngModel)]="selectBranch"
                (change)="onBranchChange()">
                <option [ngValue]="null">Select Branch</option>
                <option *ngFor="let branchName of branchList" [ngValue]="branchName">
                  {{ branchName.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="row" *ngIf="hasAccess('IT Reports')">
            <div class="col-md-3">
              <label class="col-form-label">Status</label>
            </div>
            <div class="col-md-7">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedHardwareStatus"
                (change)="getHardwareAssetsList()">
                <option value="all">All</option>
                <option value="assigned">Assigned</option>
                <option value="instock">Instock</option>
                <option value="blocked">Blocked</option>
                <option value="retired">Retired</option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-4" style="display: flex; justify-content: right;">
              <button class="btn btn-xs btn-theme" style="float: right" matTooltip="Click to add"
                matTooltipPosition="left" (click)="exportToExcelClick()" *ngIf="showExcelExportButton">
                <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Excel Export
              </button>
            </div>
            <div class="col-md-4" style="display: flex; justify-content: center;">
              <button class="btn btn-xs btn-theme" style="float: right" matTooltip="Click to add"
                matTooltipPosition="left" (click)="openModal(modalContent)" *ngIf="hasAccess('IT Reports')">
                <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Add
              </button>
            </div>
            <div class="col-md-4" style="display: flex; justify-content: lefts;">
              <button class="btn btn-xs btn-theme" style="float: right" matTooltip="Click to add"
                matTooltipPosition="left" (click)="openTransferModal(TransferModalContent)">
                <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Transfer
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-2">
        <!-- style="display: block; overflow-x: auto; white-space: nowrap" -->
        <table class="table table-bordered table-sm table-striped">
          <thead class="">
            <tr>
              <th *ngIf="hasAccess('IT Reports')">Action</th>
              <th>Sr.No.</th>
              <th>Employee Name</th>
              <th>Partner Name</th>
              <th>Hardware Type</th>
              <th>Hardware Serial Tag</th>
              <th>Personal/PGB Asset</th>
              <th>Branch</th>
              <th *ngIf="hasAccess('IT Reports')">Status</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of hardwareAssetsList;let i=index">
            <td *ngIf="hasAccess('IT Reports')">
              <a style="color: #800000; cursor: pointer;padding-left:10px;text-decoration: underline;"
                (click)="viewHardwareAssets(data,viewModalContent)">
                <span>View</span>
              </a>
              <a *ngIf="getHardwareStatus(data)=='Instock' || getHardwareStatus(data)=='Blocked'"
                style="color: #800000; cursor: pointer;padding-left:10px;text-decoration: underline;"
                (click)="blockHardwareData(data.asset)">
                <span *ngIf="!data.asset.block">Block</span>
                <span *ngIf="data.asset.block">Unblock</span>
              </a>
              <a style="color: #800000; cursor: pointer;padding-left:10px;text-decoration: underline;"
                (click)="editHardwareAsset(data,modalContent)">
                <span *ngIf="!data.asset.block">Edit</span>
              </a>
            </td>
            <td>{{i+1}}</td>
            <td>{{data.user==null?'To be assigned':data.user.firstName}} {{data.user==null?'':data.user.middleName}}
              {{data.user==null?'':data.user.lastName}}</td>
            <td>{{getPartnerName(data)}}</td>
            <td>{{data.asset.subType==null?'':data.asset.subType.name}}</td>
            <td>{{data.asset.serviceTagNumber}}</td>
            <td>{{getPersonalOrPGB(data)}}</td>
            <td>{{data.asset.branch.name}}</td>
            <td *ngIf="hasAccess('IT Reports')">{{getHardwareStatus(data)}}</td>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="container" id="mainContent">
    <div class="pt-2 pb-2" *ngIf="pendingTransferRequest.length>0">
      <div class="row">
        <div class="col-md-12" style="text-align: center">
          <span class="bg-theme-title">Pending Transfer Request</span>
        </div>
      </div>
      <div class="pt-2">
        <table class="table table-bordered table-sm table-striped">
          <thead class="">
            <tr>
              <th>Action</th>
              <th>Status</th>
              <th>Hardware Serial Tag Number</th>
              <th>Transfer From</th>
              <th>Transfer To</th>
            </tr>
          </thead>
          <tbody *ngFor="let data of pendingTransferRequest;">
            <td *ngIf="data.status=='Declined'"><a style="color: #800000; cursor: pointer;text-decoration: underline;"
                (click)="resendTransferRequest(data)">
                Resend
              </a></td>
            <td *ngIf="data.status=='Pending'">NA</td>
            <td>{{data.status}}
            </td>
            <td>{{data.asset.serviceTagNumber}}</td>
            <td>{{data.fromUser!=null?data.fromUser.firstName:'InStock'}}
              {{data.fromUser!=null?data.fromUser.middleName:''}} {{data.fromUser!=null?data.fromUser.lastName:''}}</td>
            <td>{{data.toUser.firstName}} {{data.toUser.middleName}} {{data.toUser.lastName}}</td>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title" style="text-align: center">
      Add Hardware
    </h5>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label">Type Of Hardware<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <select class="form-control form-control-xs" id="HardwareType" name="HardwareType"
              [(ngModel)]="assetsManagementModel.subType">
              <option [ngValue]="null">Select Hardware Type</option>
              <option *ngFor="let type of hardwareTypeAssetsList.subType" [ngValue]="type">
                {{ type.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Service Tag<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-4">
                <input type="text" id="serviceTag" name="serviceTag" class="form-control form-control-xs"
                  [(ngModel)]="assetsManagementModel.serviceTagNumber" />
              </div>
              <div class="col-sm-6">
                <input type="file" id="serviceTag" name="serviceTag" (change)="fileChange($event,'serviceTag')" />
              </div>
              <div class="col-sm-2" *ngIf="assetsManagementModel.serviceTagNumberUrl != null">
                <a href="{{ assetsManagementModel.serviceTagNumberUrl }}" target="_blank" rel="noopener noreferrer">
                  <i class="fa fa-download fa-lg" aria-hidden="true"></i> </a>
                <!-- <span>{{ assetsManagementModel.serviceTagNumberUrl }}</span> -->
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop'|| assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Make<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="make" name="make" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.make" />
          </div>
        </div>
      </div>

      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop'|| assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Model No.<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="modelNo" name="modelNo" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.modelNo" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <select class="form-control form-control-xs" id="BranchName" name="BranchName"
              [(ngModel)]="assetsManagementModel.branch">
              <option [ngValue]="null">Select Branch</option>
              <option *ngFor="let branchName of branchList" [ngValue]="branchName">
                {{ branchName.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-sm-6" *ngIf="assetsManagementModel.subType.name=='Dongle'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Service Provider
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="serviceProvider" name="serviceProvider" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.serviceProvider" />
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row" >
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Branch<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <select
              class="form-control form-control-xs"
              id="BranchName"
              name="BranchName"
              [(ngModel)]="assetsManagementModel.branch"
            >
              <option [ngValue]="null">Select Branch</option>
              <option *ngFor="let branchName of branchList" [ngValue]="branchName">
                {{ branchName.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Date Of Purchase<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <div class="input-group">
              <input
                id="purchaseDate"
                name="purchaseDate"
                class="form-control form-control-xs"
                placeholder="dd/mm/yyyy"
                ngbDatepicker
                #purchaseDate="ngbDatepicker"
                [(ngModel)]="assetsManagementModel.dateOfPurchase"
              />

              <div class="input-group-append">
                <button
                  class="btn btn-outline-theme calendar btn-xs"
                  (click)="purchaseDate.toggle()"
                  type="button"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div class="row">
      <div class="col-sm-6" *ngIf="assetsManagementModel.subType.name=='Dongle'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              SIM No.
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="simNo" name="simNo" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.simNo" />
          </div>
        </div>
      </div>

      <div class="col-sm-6" *ngIf="assetsManagementModel.subType.name=='Dongle'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Account No.
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="accountNo" name="accountNo" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.accountNo" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label">Date Of Purchase<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <div class="input-group">
              <input id="purchaseDate" name="purchaseDate" class="form-control form-control-xs" placeholder="dd/mm/yyyy"
                ngbDatepicker #purchaseDate="ngbDatepicker" [(ngModel)]="assetsManagementModel.dateOfPurchase"
                [minDate]="twoMonthbeforeCurrentDate" [maxDate]="currentDate" />

              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs" (click)="purchaseDate.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Photo PGB Purchase accounting voucher no.
            </label>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-6">
                <input type="file" id="pgbPurchaseVoucherPhoto" name="pgbPurchaseVoucherPhoto"
                  (change)="fileChange($event,'pgbPurchaseVoucherPhoto')" />
              </div>
              <div class="col-sm-6" *ngIf="assetsManagementModel.pgbPurchaseVoucherPhotoUrl != null">
                <a href="{{ assetsManagementModel.pgbPurchaseVoucherPhotoUrl }}" target="_blank"
                  rel="noopener noreferrer">
                  <i class="fa fa-download fa-lg" aria-hidden="true"></i> </a>
                <!-- <span>{{ assetsManagementModel.pgbPurchaseVoucherPhotoUrl }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              PGB Purchase accounting voucher no. <span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="pgbPurchaseAccountingVoucherNo" name="pgbPurchaseAccountingVoucherNo"
              class="form-control form-control-xs" [(ngModel)]="assetsManagementModel.pgbPurchaseAccountingVoucherNo" />
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label">PGB Purchase accounting voucher date<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <div class="input-group">
              <input id="pgbPurchaseAccountingVoucherDate" name="pgbPurchaseAccountingVoucherDate"
                class="form-control form-control-xs" placeholder="dd/mm/yyyy" ngbDatepicker
                #pgbPurchaseAccountingVoucherDate="ngbDatepicker"
                [(ngModel)]="assetsManagementModel.pgbPurchaseAccountingVoucherDate"
                [minDate]="twoMonthbeforeCurrentDate" [maxDate]="currentDate" />

              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs"
                  (click)="pgbPurchaseAccountingVoucherDate.toggle()" type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Vendor Invoice No.<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="vendorInvoiceNo" name="vendorInvoiceNo" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.vendorInvoiceNo" />
          </div>
        </div>
      </div>


      <div class="col-sm-6">
        <div class="row">
          <label class="col-sm-4 col-form-label">Vendor Invoice date<span class="text-danger">*</span>
          </label>
          <div class="col-sm-8">
            <div class="input-group">
              <input id="vendorInvoiceDate" name="vendorInvoiceDate" class="form-control form-control-xs"
                placeholder="dd/mm/yyyy" ngbDatepicker #vendorInvoiceDate="ngbDatepicker"
                [(ngModel)]="assetsManagementModel.vendorInvoiceDate" [minDate]="twoMonthbeforeCurrentDate"
                [maxDate]="currentDate" />

              <div class="input-group-append">
                <button class="btn btn-outline-theme calendar btn-xs" (click)="vendorInvoiceDate.toggle()"
                  type="button"></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Photo of Vendor Invoice
            </label>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-6">
                <input type="file" id="vendorInvoicePhoto" name="vendorInvoicePhoto"
                  (change)="fileChange($event,'vendorInvoicePhoto')" />
              </div>

              <div class="col-sm-6" *ngIf="assetsManagementModel.vendorInvoicePhotoUrl != null">
                <a href="{{ assetsManagementModel.vendorInvoicePhotoUrl }}" target="_blank" rel="noopener noreferrer">
                  <i class="fa fa-download fa-lg" aria-hidden="true"></i> </a>
                <!-- <span>{{ assetsManagementModel.vendorInvoicePhotoUrl }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              System Config
            </label>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-6">
                <input type="file" id="systemConfig" name="systemConfig" (change)="fileChange($event,'systemConfig')" />
              </div>
              <div class="col-sm-6" *ngIf="assetsManagementModel.systemConfigUrl != null">
                <a href="{{ assetsManagementModel.systemConfigUrl }}" target="_blank" rel="noopener noreferrer">
                  <i class="fa fa-download fa-lg" aria-hidden="true"></i> </a>
                <!-- <span>{{ assetsManagementModel.systemConfigUrl }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Access points'|| assetsManagementModel.subType.name=='Router'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              IPAddress
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="ipAddress" name="ipAddress" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.ipAddress" />
          </div>
        </div>
      </div>
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Access points' || assetsManagementModel.subType.name=='Router'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              User Id
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="userId" name="userId" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.userId" />
          </div>
        </div>
      </div>
    </div>

    <div class="row"
      *ngIf="assetsManagementModel.subType.name=='Access points' || assetsManagementModel.subType.name=='Router'">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Password
            </label>
          </div>
          <div class="col-sm-8">
            <input type="text" id="password" name="password" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.password" />
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <!-- <div class="form-group mb-0" style="margin-top: -2%"> -->
        <div class="row">
          <div class="col-sm-6">
            <div class="form-check form-check-inline">
              <label class="col-form-label">Personal Asset <span class="text-danger">*</span></label>
              <input class="form-check-input ml-4" type="radio" name="Cost" id="Cost"
                [(ngModel)]="assetsManagementModel.personalAsset" [value]="true" />
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-check form-check-inline">
              <label class="col-form-label">PGB Asset <span class="text-danger">*</span></label>
              <input class="form-check-input ml-4" type="radio" name="mandays" id="mandays"
                [(ngModel)]="assetsManagementModel.personalAsset" [value]="false" />
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Pen Drive Blocked<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8 col-form-label">
            <input type="radio" id="penDriveBlockedYes" name="penDriveBlocked"
              [(ngModel)]="assetsManagementModel.penDriveBlocked" [value]="true" />
              &nbsp;
            <label class="form-check-label" for="penDriveBlockedYes">Yes</label>
            &nbsp;&nbsp;&nbsp;
            <input type="radio" id="penDriveBlockedNo" name="penDriveBlocked"
              [(ngModel)]="assetsManagementModel.penDriveBlocked" [value]="false" />
              &nbsp;
            <label class="form-check-label" for="penDriveBlockedNo">No</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Recovery Disk Prepared<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8 col-form-label">
            <input type="radio" id="recoveryDiskPreparedYes" name="recoveryDiskPrepared"
              [(ngModel)]="assetsManagementModel.recoveryDiskPrepared" [value]="true" />
              &nbsp;
            <label class="form-check-label" for="recoveryDiskPreparedYes">Yes</label>
            &nbsp;&nbsp;&nbsp;
            <input type="radio" id="recoveryDiskPreparedNo" name="recoveryDiskPrepared"
              [(ngModel)]="assetsManagementModel.recoveryDiskPrepared" [value]="false" />
              &nbsp;
            <label class="form-check-label" for="recoveryDiskPreparedNo">No</label>
          </div>
        </div>
      </div>
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Admin/Guest User Prepared<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8 col-form-label">
           <input type="radio" id="adminGuestUserPreparedYes" name="adminGuestUserPrepared"
              [(ngModel)]="assetsManagementModel.adminGuestUserPrepared" [value]="true" />
              &nbsp;
            <label class="form-check-label" for="penDriveBlockedYes">Yes</label>
            &nbsp;&nbsp;&nbsp;
            <input type="radio" id="penDriveBlockedNo" name="adminGuestUserPrepared"
              [(ngModel)]="assetsManagementModel.adminGuestUserPrepared" [value]="false" />
              &nbsp;
            <label class="form-check-label" for="adminGuestUserPreparedNo">No</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Belarc Installed<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-3">
                <input type="checkbox" id="belarInstall" name="belarInstall"
                  [(ngModel)]="assetsManagementModel.belarcInstalled" />
              </div>
              <div class="col-sm-7">
                <input type="file" id="belarcInstalled" name="belarcInstalled" (change)="fileChange($event,'belarc')" />
              </div>
              <div class="col-sm-2" *ngIf="assetsManagementModel.belarcUrl  != null">
                <a href="{{ assetsManagementModel.belarcUrl  }}" target="_blank" rel="noopener noreferrer">
                  <i class="fa fa-download fa-lg" aria-hidden="true"></i> </a>
                <!-- <span>{{ assetsManagementModel.serviceTagNumberUrl }}</span> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Remote Access Software Installed<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8 col-form-label">
            <input type="radio" id="remoteInstallYes" name="remoteInstall"
              [(ngModel)]="assetsManagementModel.remoteAccessSoftwareInstalled" [value]="true" />
              &nbsp;
            <label class="form-check-label" for="remoteInstallYes">Yes</label>
            &nbsp;&nbsp;&nbsp;
            <input type="radio" id="remoteInstallNo" name="remoteInstall"
              [(ngModel)]="assetsManagementModel.remoteAccessSoftwareInstalled" [value]="false" />
              &nbsp;
            <label class="form-check-label" for="remoteInstallNo">No</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Cyberoam Installed<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8 col-form-label">
            <input type="radio" id="cyberoamInstallYes" name="cyberoamInstall"
              [(ngModel)]="assetsManagementModel.cyberoamInstalled" [value]="true" />
              &nbsp;
            <label class="form-check-label" for="cyberoamInstallYes">Yes</label>
            &nbsp;&nbsp;&nbsp;
            <input type="radio" id="cyberoamInstallNo" name="cyberoamInstall"
              [(ngModel)]="assetsManagementModel.cyberoamInstalled" [value]="false" />
              &nbsp;
            <label class="form-check-label" for="cyberoamInstallNo">No</label>
          </div>
        </div>
      </div>
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Printer Access Installed<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8 col-form-label">
            <input type="radio" id="printerInstallYes" name="printerInstall"
              [(ngModel)]="assetsManagementModel.printerAccessInstalled" [value]="true" />
              &nbsp;
            <label class="form-check-label" for="printerInstallYes">Yes</label>
            &nbsp;&nbsp;&nbsp;
            <input type="radio" id="printerInstallNo" name="printerInstall"
              [(ngModel)]="assetsManagementModel.printerAccessInstalled" [value]="false" />
              &nbsp;
            <label class="form-check-label" for="printerInstallNo">No</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              PGB Tag Affixed<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8 col-form-label">
            <input type="radio" id="pgbTagAffixedYes" name="pgbTagAffixed"
              [(ngModel)]="assetsManagementModel.pgbTagAffixed" [value]="true" />
              &nbsp;
            <label class="form-check-label" for="pgbTagAffixedYes">Yes</label>
            &nbsp;&nbsp;&nbsp;
            <input type="radio" id="pgbTagAffixedNo" name="pgbTagAffixed"
              [(ngModel)]="assetsManagementModel.pgbTagAffixed" [value]="false" />
              &nbsp;
            <label class="form-check-label" for="pgbTagAffixedNo">No</label>
          </div>
        </div>
      </div>
      <div class="col-sm-6"
        *ngIf="assetsManagementModel.subType.name=='Laptop' || assetsManagementModel.subType.name=='Dekstop'">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Serial/Service Tag Affixed<span class="text-danger">*</span>
            </label>
          </div>
          <div class="col-sm-8 col-form-label">
            <input type="radio" id="serialTagAffixedYes" name="serialTagAffixed"
              [(ngModel)]="assetsManagementModel.serialServiceTagAffixed" [value]="true" />
              &nbsp;
            <label class="form-check-label" for="serialTagAffixedYes">Yes</label>
            &nbsp;&nbsp;&nbsp;
            <input type="radio" id="serialTagAffixedNo" name="serialTagAffixed"
              [(ngModel)]="assetsManagementModel.serialServiceTagAffixed" [value]="false" />
              &nbsp;
            <label class="form-check-label" for="serialTagAffixedNo">No</label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Date Of Retirement Of Asset
            </label>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-4"><input type="checkbox" id="retirementAssetDate" name="retirementAssetDate"
                  [(ngModel)]="assetsManagementModel.retired" /></div>
              <div class="col-sm-8" *ngIf="assetsManagementModel.retired">
                <div class="input-group">
                  <input id="releaseDate" name="releaseDate" class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy" ngbDatepicker #releaseDate="ngbDatepicker"
                    [(ngModel)]="assetsManagementModel.dateOfRetirementOfAsset" [minDate]="currentDate" />

                  <div class="input-group-append">
                    <button class="btn btn-outline-theme calendar btn-xs" (click)="releaseDate.toggle()"
                      type="button"></button>
                  </div><span class="text-danger">*</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-sm-6" *ngIf="showDateOfSale">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Date Of Sale/Discarding
            </label>
          </div>
          <div class="col-sm-8">
            <div class="row">
              <div class="col-sm-4">
                <input type="checkbox" id="saleDiscardingDate" name="saleDiscardingDate"
                  [(ngModel)]="assetsManagementModel.release" />
              </div>
              <div class="col-sm-8" *ngIf="assetsManagementModel.release">
                <div class="input-group">
                  <input id="releaseDate" name="releaseDate" class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy" ngbDatepicker #releaseDate="ngbDatepicker"
                    [(ngModel)]="assetsManagementModel.dateOfSale" [minDate]="currentDate" />

                  <div class="input-group-append">
                    <button class="btn btn-outline-theme calendar btn-xs" (click)="releaseDate.toggle()"
                      type="button"></button>
                  </div><span class="text-danger">*</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-4">
            <label class="col-form-label">
              Comments
            </label>
          </div>
          <div class="col-sm-8">
            <textarea type="text" id="comments" name="comments" class="form-control form-control-xs"
              [(ngModel)]="assetsManagementModel.comment"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-md-6"></div>
      <div class="col-md-3">
        <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onAddHardwareAssets()"
          *ngIf="!hideSaveButton">
          Save
        </button>
        <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onAddHardwareAssets()"
          *ngIf="hideSaveButton">
          Update
        </button>
      </div>
      <div class="col-sm-3">
        <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #TransferModalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title" style="text-align: center">
      Transfer Hardware
    </h5>
  </div>
  <div class="modal-body">
    <!-- <div class="row">
                <div class="col-sm-4">
                  <label class="col-form-label">
                      Service / Serial Tag<span class="text-danger">*</span>
                  </label>
                </div>
                <div class="col-sm-8">
                  <input
                    type="text"
                    id="serialTag"
                    name="serialTag"
                    class="form-control form-control-xs"
                    [ngbTypeahead]="search"
                    [inputFormatter]="inputFormatter"
                    [resultFormatter]="inputFormatter"
                    [editable]='true'
                    (selectItem)="setFromUserValue($event)"
                    (change)="checkSerialTagNumber()"
                    [(ngModel)]="serialTagNumber"/>
                </div>
      </div> -->

    <div class="row">
      <label class="col-sm-4 col-form-label">Service / Serial Tag<span class="text-danger">*</span>
      </label>
      <div class="col-sm-8">
        <select class="form-control form-control-xs" id="serviceTagNumber" name="serviceTagNumber"
          [(ngModel)]="selectedSerialTag" (change)="setFromUserValue()">
          <option [ngValue]="null">Select Serial Tag Number</option>
          <option *ngFor="let srialTagName of serialTagList" [ngValue]="srialTagName">
            {{ srialTagName.serviceTagNumber }}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-4 col-form-label">Transfer From<span class="text-danger">*</span>
      </label>
      <div class="col-sm-8">
        <span *ngIf="mainAssetModel.fromUser!=undefined">{{mainAssetModel.fromUser.firstName}}
          {{mainAssetModel.fromUser.middleName}} {{mainAssetModel.fromUser.lastName}}</span>
        <span *ngIf="mainAssetModel.fromUser==undefined">InStock</span>
      </div>
    </div>

    <div class="row">
      <label class="col-sm-4 col-form-label">Transfer To<span class="text-danger">*</span>
      </label>
      <div class="col-sm-8">
        <select class="form-control form-control-xs" id="transferTo" name="transferTo"
          [(ngModel)]="mainAssetModel.toUser">
          <option [ngValue]="null">Select Transfer To</option>
          <option *ngFor="let user of userList" [ngValue]="user">
            {{ user.firstName }} {{user.middleName}} {{user.lastName}}
          </option>
        </select>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-4">
        <label for="approversName">Transfer Date<span class="text-danger">*</span>
        </label>
      </div>
      <div class="col-sm-8">
        <div class="input-group">
          <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="requsetDate" ngbDatepicker
            #requsetDate="ngbDatepicker" [(ngModel)]="mainAssetModel.requsetDate" [minDate]="previousMonthCurrentDate"
            [maxDate]="currentDate" />
          <div class="input-group-append">
            <button class="btn btn-outline-theme calendar" (click)="requsetDate.toggle()" type="button"></button>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="row">
        <div class="col-sm-4">
          <label class="col-form-label">
              Release<span class="text-danger">*</span>
          </label>
        </div>
        <div class="col-sm-4 col-form-label" style="font-weight: bold">
            <input type="checkbox" id="release"
            name="release" value="false" />
          </div>
   </div> -->
  </div>

  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-md-6"></div>
      <div class="col-md-3">
        <button type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="excuteTransferDetails()">
          Execute
        </button>
      </div>
      <div class="col-sm-3">
        <button type="button" class="btn btn-sm btn-block btn-outline-secondary" (click)="closeModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #viewModalContent let-modalView>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">View Hardware Details</h5>
  </div>
  <div class="modal-body">
    <div class="row mt-1">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Employee Name</label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.user!=null?viewHardwareAssetDetails.user.firstName:'To be assigned'}}
              {{viewHardwareAssetDetails.user!=null?viewHardwareAssetDetails.user.middleName:''}}
              {{viewHardwareAssetDetails.user!=null?viewHardwareAssetDetails.user.lastName:''}}</span>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Branch </label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.branch.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Service Tag Number</label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.serviceTagNumber}}</span>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Type Of Hardware</label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.subType.name}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- <div class="col-sm-6">
    <div class="row">
    <div class="col-sm-6"><label>Hardware Name</label></div>
    <div class="col-sm-6">
      <label>: &nbsp;&nbsp;</label>
      <span>{{viewHardwareAssetDetails.asset.assetName}}</span>
    </div>
  </div>
  </div> -->
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Make</label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.make}}</span>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Model No.</label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.modelNo}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- <div class="col-sm-6">
    <div class="row">
      <div class="col-sm-6"><label>Date Of Purchase</label></div>
      <div class="col-sm-6">
        <label>: &nbsp;&nbsp;</label>
        <span>{{viewHardwareAssetDetails.asset.dateOfPurchase | date:'dd-MMMM-yyyy'}}</span>
      </div>
    </div>
  </div> -->
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Retirement Date </label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.dateOfRetirementOfAsset |date:'dd-MMMM-yyyy'}}</span>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Date Of Sale</label></div>
          <div class="col-sm-6">
            <label>:&nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.dateOfSale |date:'dd-MMMM-yyyy'}}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Personal/PGB Asset</label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.personalAsset==true?'Personal':'PGB'}}</span>
          </div>
        </div>
      </div>

      <div class="col-sm-6">
        <div class="row">
          <div class="col-sm-6"><label>Comments</label></div>
          <div class="col-sm-6">
            <label>: &nbsp;&nbsp;</label>
            <span>{{viewHardwareAssetDetails.asset.comment}}</span>
          </div>
        </div>
      </div>
    </div>

  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-9"></div>
      <div class="col-sm-3">
        <button id="closeAssignmentBtn" name="closeAssignmentBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modalView.dismiss('Cross click')">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>